import { DEFAULT_CRM_SYSTEM } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";
import { getOrganizationById } from "@/features/organization/hooks/useQuery/useGetOrganizationById";
import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const getOrgCrmListByOrgId = async (orgId: Tables<"organisation">["id"]) => {
    const orgData = await getOrganizationById(orgId);
    return await supabase
        .from('crm')
        .select(`*, default_configuration,crm_config(*),crm_project(*), organisation_crm!inner(*)`)
        .eq('organisation_crm.organisation_id', orgId)
        .in('crm_system', orgData.crm_connections ?? [DEFAULT_CRM_SYSTEM])
        .throwOnError()
        .then(res => res.data);
}